import ContentConfig from '../../../config/ContentConfig';
import logger from '../../../log';
import tracksMatch from '../../../reporter/util/tracksMatch';
import { ConstructedEvents } from '../constants';
import { EventReport, PlayerEventReporter } from './interfaces';

const log = logger.getLogger(__filename);

const {
  audiochanged: { code: at },
  captionchanged: { code: ct }
} = ConstructedEvents;

const codeMapping = { [at]: 'at', [ct]: 'ct' };

const trackChangeHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  const type = codeMapping[event.e] as 'ct' | 'at' | undefined;
  if (typeof type === 'undefined') {
    return false;
  }
  if (!ContentConfig.getInstance().report.enableEngagementEvent) {
    log.trace('Not sending track event because event is disabled');
    return true;
  }
  const eventState = reporter.localState.event;
  if (!event.s && tracksMatch(event[type], eventState[type])) {
    return true;
  }
  eventState[type] = event[type];
  reporter.pending.events.data.push(event);
  return true;
};

export default trackChangeHandler;
